/** HLS/MP4/YouTube level for one paired TV, independent of people and music. */
export const TV_MEDIA_AUDIO_READ = 'tv:media-audio:read';
export const TV_MEDIA_AUDIO_UPDATE = 'tv:media-audio:update';
export const TV_MEDIA_AUDIO_STATE = 'tv:media-audio:state';
export interface TvMediaAudioSettings { muted: boolean; volume: number; revision: number }
export type TvMediaAudioChange = Partial<Pick<TvMediaAudioSettings, 'muted' | 'volume'>>;
export const DEFAULT_TV_MEDIA_AUDIO: TvMediaAudioSettings = { muted: false, volume: 1, revision: 0 };
export function isTvMediaAudioChange(value: unknown): value is TvMediaAudioChange {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return false;
  const v = value as Record<string, unknown>;
  const keys = Object.keys(v);
  return keys.length > 0 && keys.every(key => key === 'muted' ? typeof v.muted === 'boolean'
    : key === 'volume' && typeof v.volume === 'number' && Number.isFinite(v.volume) && v.volume >= 0 && v.volume <= 1);
}
export function isTvMediaAudioSettings(value: unknown): value is TvMediaAudioSettings {
  if (!value || typeof value !== 'object') return false;
  const v = value as TvMediaAudioSettings;
  return isTvMediaAudioChange({ muted: v.muted, volume: v.volume }) && Number.isSafeInteger(v.revision) && v.revision >= 0;
}
